/**
 * Logo Component
 * Displays the Dark Star Labs logo at the top center of the screen
 */

export function Logo({ className = '' }) {
  return (
    <div className={`dsl-logo-container ${className}`}>
      <span className="dsl-logo-powered-by">powered by</span>
      <a href="https://darkstarlabs.io" target="_blank" rel="noopener noreferrer">
        <img
          src="/logos/DSL Logo Stacked Light and Orange.svg"
          alt="Dark Star Labs"
          className="dsl-logo dsl-logo--stacked"
        />
        <img
          src="/images/dslBrand/DSL Logo Light and Orange.png"
          alt="Dark Star Labs"
          className="dsl-logo dsl-logo--horizontal"
        />
      </a>
    </div>
  )
}

export default Logo
